import { connect } from 'react-redux';
import { setPreviousFiltersAction } from 'src/store/previousFilters/actions';
import {
  isSuggestedFiltersShownSelector,
  previousFiltersForCurrentSearchSelector,
} from 'src/store/previousFilters/selectors';
import { setIsPreviousFiltersShown } from 'src/store/previousFilters/slice';
import SuggestedFilters from './SuggestedFilters';

const mapStateToProps = (state) => ({
  filters: previousFiltersForCurrentSearchSelector(state),
  isShown: isSuggestedFiltersShownSelector(state),
});
const mapDispatchToProps = {
  applyPreviousFilters: setPreviousFiltersAction,
  setIsShowing: setIsPreviousFiltersShown,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedFilters);
